import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMMSiteNotifications } from '@apps-common/types/my-monitoring'

export const updateMyMonitoringSiteNotifications = async (model: IMMSiteNotifications): Promise<IMMSiteNotifications> =>
  axios.post(`/my-monitoring/sites/UpdateSiteNotifications`, model).then((res) => res?.data?.data)

type Props = {
  model: IMMSiteNotifications
}

export const useMyMonitoringUpdateSiteNotifications = (notify?: boolean, onSuccess?: (data: IMMSiteNotifications) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringSiteNotifications'],
    mutationFn: ({ model }: Props) => updateMyMonitoringSiteNotifications(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated site notifications.')
      }
    },
    onError: (error) => {
      // if (notify) {
      toastError(error?.message || 'Failed to update site notifications.')
      // }
    },
    throwOnError: false
  })
